var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 89,
    height: 73.709,
    viewBox: "0 0 89 73.709",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_177-2",
    x: 10.875,
    y: 0,
    width: 66.279,
    height: 53.472,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.235
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3948",
    "data-name": "Group 3948",
    transform: "translate(6573.357 -4117.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3916",
    "data-name": "Group 3916",
    transform: "translate(493.189 32.307)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7066.55, 4085.07)",
    filter: "url(#Path_177-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177-2-2",
    "data-name": "Path 177-2",
    d: "M1512.361-85.8c2.358-7.35,2.291-14.971,2.512-22.546.049-1.67-.26-2.7,2.231-2.582q19.453.923,38.928,1.324c2.21.046,2.5.837,2.481,2.584-.077,6.192-.136,12.385-.125,18.578,0,2.063-.524,3.205-2.9,3.457-5.648.6-11.268,2.032-16.964,1.031-3.067-.54-6.236,2.363-9.227-.409-.187-.175-1.476.772-2.211,1.26-5.077,3.372-10.565,6.007-15.947,8.826-.812.425-1.762,1.491-2.67.348-.769-.972.365-1.54.866-2.2C1511.514-78.994,1511.115-82.659,1512.361-85.8Z",
    transform: "translate(-1489.36 118.94)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCt);
export default __webpack_public_path__ + "static/media/CT.91dac2c52e15c26721ebb89405405048.svg";
export { ForwardRef as ReactComponent };